import { Button, Drawer, Form, Select, Switch } from "antd";
import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { authenticateToken } from "../../utils/auth";
import { getPage, jcTypeArray } from "../../utils/index";
import Loading from "../common/Loader";
import PaginationTwo from "../common/PaginationTwo";
import { CheckOutlined, CloseOutlined, EditOutlined } from "@ant-design/icons";
import TopHeading from "./TopHeading";
import Empty from "../common/Empty";
import AddServiceGroup from "./AddGroup";
import { responseNotification } from "../../utils/notify";
import GroupDetails from "./details";
const { Option } = Select;

const AdminGroupList = () => {
  const [type, setType] = useState("JC_MART");
  const [limit, setLimit] = useState(16);
  const [groupData, setGroupData] = useState({
    loading: false,
    data: null,
  });
  const [selectedGroup, setSelectedGroup] = useState(undefined);
  const [selectedGroupForEdit, setSelectedGroupForEdit] = useState(undefined);
  const [visible, setVisible] = useState(undefined);
  const loc = useLocation();
  const [form] = Form.useForm();

  const getAdminGroup = useCallback(async () => {
    setGroupData({ loading: true, data: null });
    const encodedUri = `${process.env.REACT_APP_AUTH_API}`;
    axios
      .get(`${encodedUri}/group/all?type=${type}`, {
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
        },
      })
      .then((res) => {
        setGroupData({ loading: false, data: res.data });
      })
      .catch((err) => {
        setGroupData({ loading: false, data: [] });
        console.error("Feedback Type: Error", err);
      });
  }, [type]);

  //
  const onStatusChange = async (id, val) => {
    if (id) {
      await fetch(`${process.env.REACT_APP_AUTH_API}/group`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: id,
          isActive: val,
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          if (res.statusCode === 200) {
            responseNotification("Status Updated Successfully", "success");
            getAdminGroup();
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    }
  };
  //

  useEffect(() => {
    getAdminGroup();
  }, [getAdminGroup]);

  useEffect(() => {
    if (visible) {
      setSelectedGroup(undefined);
      setSelectedGroupForEdit(undefined);
    }
  }, [visible]);

  useEffect(() => {
    setSelectedGroup(undefined);
    setSelectedGroupForEdit(undefined);
  }, [visible]);

  const onClose = () => {
    setSelectedGroup(null);
    setSelectedGroupForEdit(null);
    getAdminGroup();
  };

  return (
    <React.Fragment>
      <TopHeading {...groupData?.data?.totalElements} refetch={getAdminGroup} />
      <section className="search_area">
        <Form form={form} className="search_form">
          <Form.Item initialValue={type}>
            <Select
              placeholder="Product Type"
              onChange={(val) => setType(val)}
              value={type}
              style={{ minWidth: 300 }}
            >
              {Object.values(jcTypeArray)?.map((type, i) => (
                <Option value={type} key={i}>
                  {type?.replace("_", " ")}
                </Option>
              ))}
            </Select>
          </Form.Item>

          {/* <Form.Item initialValue={null}>
            <Select
              placeholder="Status"
              onChange={(val) => setStatus(val)}
              value={status}
            >
              <Option value={""}>ALL</Option>
              <Option value={"true"}>ACTIVE</Option>
              <Option value={"false"}>INACTIVE</Option>
            </Select>
          </Form.Item> */}
        </Form>
        {/* <div className="search_btn">
          <Button type="primary" danger size="large" onClick={reseAllFieldData}>
            Reset
          </Button>
        </div> */}
      </section>

      <div className="product-list-item-area white-bg section-padding-bottom">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="product-list-items-inner-content">
                <div className="single-product-wrapper">
                  <div className="single-product-heading">
                    <span>Admin Group</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Type</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Status</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Action</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            {groupData?.loading ? (
              <Loading />
            ) : (
              <div className="col-lg-12 product-table">
                <div className="product-table-area">
                  {groupData?.data?.groups?.length ? (
                    groupData?.data?.groups?.map((group: any, index: any) => (
                      <React.Fragment key={index}>
                        <div
                          className="single-product-wrapper"
                          onClick={() => setSelectedGroup(group)}
                        >
                          <div className="single-product">
                            <span className="name">{group?.name}</span>
                          </div>
                          <div className="single-product">
                            <span className="name">
                              {group?.type?.replace("_", " ")}
                            </span>
                          </div>
                          <div className="single-product">
                            <Switch
                              checkedChildren={<CheckOutlined />}
                              unCheckedChildren={<CloseOutlined />}
                              defaultChecked={group?.isActive}
                              onChange={(val, e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                onStatusChange(group?.id, val);
                              }}
                            />
                          </div>
                          <div className="single-product">
                            <Button
                              onClick={() => setSelectedGroupForEdit(group)}
                            >
                              <EditOutlined />
                            </Button>
                          </div>
                        </div>
                      </React.Fragment>
                    ))
                  ) : (
                    <Empty data="Admin Group" />
                  )}
                </div>
              </div>
            )}
          </div>

          <Drawer
            title={selectedGroupForEdit ? "Edit Group" : "Group Details"}
            width={450}
            onClose={onClose}
            visible={selectedGroup || selectedGroupForEdit}
            bodyStyle={{ paddingBottom: 80 }}
            footer={
              <div
                style={{
                  textAlign: "right",
                }}
              ></div>
            }
          >
            {selectedGroupForEdit ? (
              <AddServiceGroup
                visibleData={selectedGroupForEdit}
                onCloseMethod={onClose}
              />
            ) : (
              <GroupDetails GroupDetails={selectedGroup} />
            )}
          </Drawer>

          <PaginationTwo
            {...groupData?.data}
            limit={limit}
            page={getPage(loc.search)}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default AdminGroupList;
